import Head from 'next/head';
import type { ReactNode } from 'react';

interface ISeoMetaProps {
  title: string;
  description: string;
  canonical: string;
  children?: ReactNode;
  indexingDisabled?: boolean;
  ogTitle?: string;
  ogDescription?: string;
}

export const SeoMeta = ({
  title,
  description,
  canonical,
  indexingDisabled,
  ogTitle,
  ogDescription,
  children,
}: ISeoMetaProps) => (
  <Head>
    <title key="title">{title}</title>
    <meta key="description" name="description" content={description} />
    <link key="canonical" rel="canonical" href={canonical} />
    <meta key="robots" name="robots" content={indexingDisabled ? 'noindex, nofollow' : 'index, follow'} />
    {ogDescription && <meta key="og_description" property="og:description" content={ogDescription} />}
    {ogTitle && <meta key="og_title" property="og:title" content={ogTitle} />}
    <meta key="og_type" property="og:type" content="website" />
    <meta key="og_image" property="og:image" content="https://f.sravni.ru/f/_/logo_200x200.jpg" />
    <meta key="og_image_width" property="og:image:width" content="200" />
    <meta key="og_image_height" property="og:image:height" content="200" />
    {children && children}
  </Head>
);
